import {
    apiRequest,
    cpnsList,
    cpnsDelete
} from "../../../../../services/adapters/kepegawaian/cpnsService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", cpnsList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", cpnsDelete, {
            body: query
        }, true)
    }
}

export default DataTableRepository